// ABOUTME: The darker skyline on 3A: a warm shade over the sky band that fades in first, before the tiles and the rain.
// ABOUTME: Decoration only; it sits under the cloud stack and never catches a pointer.

import { Box } from '@mui/material';
import { keyframes } from '@emotion/react';
import { useCrossingReducedMotion } from '../../crossing/useReducedMotion';
import { CROSSING_IMPACT_SKY_MASK } from '../../../../theme/crossingTokens';
import { DISSOLVE_SEC } from './stormDissolve';

const SKY_BAND_HEIGHT = '58%';

const shade = keyframes`
  to { opacity: 1; }
`;

interface ImpactSkyMaskProps {
  still?: boolean; // there from the first paint, with no fade: the scene drawn finished (4A)
  lifted?: boolean; // fades out over DISSOLVE_SEC (4B, once forgiven); the screen removes it afterwards
}

export default function ImpactSkyMask({ still = false, lifted = false }: ImpactSkyMaskProps) {
  const reducedMotion = useCrossingReducedMotion();
  const noFade = reducedMotion || still;

  return (
    <Box
      aria-hidden
      data-testid="impact-sky-mask"
      style={lifted
        // A transition, not a keyframe, so the lift never depends on the stage's reduced-motion animation override.
        ? { opacity: 0, pointerEvents: 'none', transition: `opacity ${DISSOLVE_SEC}s ease` }
        : noFade
        ? { opacity: 1, pointerEvents: 'none' }
        : { opacity: 0, pointerEvents: 'none', animationDuration: '0.7s', animationDelay: '0.1s' }}
      sx={{
        position: 'absolute', left: 0, right: 0, top: 0, height: SKY_BAND_HEIGHT, zIndex: 0,
        backgroundColor: CROSSING_IMPACT_SKY_MASK,
        animationName: noFade || lifted ? 'none' : `${shade}`, animationTimingFunction: 'ease', animationFillMode: 'forwards',
      }}
    />
  );
}
